<template>
  <v-container>
    <v-form v-model="valid" ref="busEntity">
      <v-row>
        <v-col cols="12" md="6">
          <label
            >{{ $t("entity_type_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.entity_type"
            :items="entityType_options"
            :rules="EntityRules.entity_typeRules"
            item-text="name"
            item-value="id"
            :placeholder="$t('entity_type_placeholder')"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label v-if="addProfilePayload.entity_type == '9'"
            >{{ $t("name_of_the_charities")
            }}<span style="color: #f00">*</span></label
          >
          <label v-else
            >{{ $t("name_of_the_company_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            dense
            :placeholder="
              addProfilePayload.entity_type == '9'
                ? $t('name_of_the_charities')
                : $t('name_of_the_company_placeholder')
            "
            outlined
            required
            v-model="addProfilePayload.business_name"
            :rules="EntityRules.CompanyNameRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("registration_no_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('registration_no_placeholder')"
            dense
            outlined
            required
            v-model="addProfilePayload.registration_number"
            :rules="EntityRules.RegistrationNoRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("date_of_incorporation_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('date_of_incorporation_placeholder')"
            dense
            type="date"
            outlined
            :max="new Date().toJSON().slice(0, 10)"
            required
            v-model="addProfilePayload.dob"
            :rules="EntityRules.DoiRules"
            @change="ValidateDateofIncop(addProfilePayload.dob)"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("source_of_funds_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.source_of_fund_code"
            :items="source_options"
            item-text="name"
            item-value="id"
            :rules="EntityRules.SOFrules"
            :placeholder="$t('source_of_funds_placeholder')"
            outlined
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("nature_of_business_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addProfilePayload.nature_of_business"
            :rules="EntityRules.natureOfBusinessErrors"
            :items="natureofbusList"
            item-text="name"
            item-value="id"
            :placeholder="$t('nature_of_business_placeholder')"
            dense
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("website_business") }}</label>
          <v-text-field
            v-model="addProfilePayload.website"
            :placeholder="$t('website_placeholder')"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("contactNumber") }}<span style="color: #f00">*</span></label
          >
          <vue-phone-number-input
            default-country-code="MY"
            @update="onChangeNumber"
            :error="!isValidNumber"
            v-model="addProfilePayload.phone_number"
            :rules="EntityRules.contactNoErrors"
            class=""
          />
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("average_annual_turnover_business") }}</label>
          <v-text-field
            :placeholder="$t('average_annual_turnover_placeholder')"
            dense
            outlined
            required
            type="number"
            hide-spin-buttons
            v-model="addProfilePayload.salary_range"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("businessEmail") }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            v-model="addProfilePayload.business_email"
            :rules="EntityRules.emailValidations"
            :placeholder="$t('email_business')"
            dense
            outlined
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("corporate_address_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('corporate_address_placeholder')"
            outlined
            required
            dense
            v-model="addressInfo.mailing_address"
            :rules="EntityRules.corporateAddErrors"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("country_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            :placeholder="$t('select_country_placeholder')"
            :items="country_options"
            v-model="addressInfo.mailing_country"
            item-text="name"
            item-value="id"
            :rules="EntityRules.countryErrors"
            @input="onChangeCounty($event)"
            outlined
            required
            dense
            disabled
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("state_business") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addressInfo.mailing_state"
            :items="state_options"
            :placeholder="$t('select_state_placeholder')"
            item-text="name"
            item-value="id"
            outlined
            required
            :rules="EntityRules.mailingStateErrors"
            @input="onChangeState($event, true)"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("city") }}<span style="color: #f00">*</span></label>
          <v-autocomplete
            v-if="haveCities"
            v-model="addressInfo.mailing_city"
            :placeholder="$t('select_city_placeholder')"
            :items="city_options"
            item-text="txt"
            item-value="val"
            :rules="EntityRules.mailingCityErrors"
            outlined
            required
            dense
          >
          </v-autocomplete>
          <v-text-field
            v-else
            v-model="addressInfo.mailing_city"
            :placeholder="$t('enter_city')"
            :rules="EntityRules.citytextErrors"
            outlined
            required
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("postalCode") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="addressInfo.mailing_postal_code"
            :items="postalCodeslist"
            :rules="EntityRules.postalCodeErrors"
            :placeholder="$t('postal_code_placeholder')"
            outlined
            dense
          ></v-autocomplete>
        </v-col>

        <!-- <label>{{ $t("mailingAddress") }}</label> -->
        <v-col cols="12" md="6" class="mt-4">
          <v-checkbox
            v-model="
              addProfilePayload.is_mailing_address_same_as_business_address
            "
            :label="$t('sameAsBusinessAddress')"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row
        v-if="!addProfilePayload.is_mailing_address_same_as_business_address"
      >
        <v-col cols="12" md="6">
          <label>{{ $t("street_no") }}</label>
          <v-text-field
            :placeholder="$t('street_no_placeholder')"
            outlined
            dense
            v-model="businessAddress.street_number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <label
            >{{ $t("business_address")
            }}<span style="color: #f00">*</span></label
          >
          <v-text-field
            :placeholder="$t('Enter Business Address')"
            outlined
            required
            dense
            v-model="businessAddress.address"
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.corporateAddErrors
                : []
            "
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("country_business")
            }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            :placeholder="$t('select_country_placeholder')"
            :items="country_options"
            v-model="businessAddress.country_code"
            item-text="name"
            item-value="id"
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.countryErrors
                : []
            "
            @input="onChangeCounty($event)"
            outlined
            required
            dense
            disabled
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("state_business") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="businessAddress.state_code"
            :items="state_options"
            :placeholder="$t('select_state_placeholder')"
            item-text="name"
            item-value="id"
            outlined
            required
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.stateErrors
                : []
            "
            @input="onChangemailingState($event, true)"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("city") }}<span style="color: #f00">*</span></label>
          <v-autocomplete
            v-if="haveBusCities"
            v-model="businessAddress.city_code"
            :placeholder="$t('select_city_placeholder')"
            :items="maling_city_options"
            item-text="txt"
            item-value="val"
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.cityErrors
                : []
            "
            outlined
            required
            dense
          >
          </v-autocomplete>
          <v-text-field
            v-else
            v-model="businessAddress.city_code"
            :placeholder="$t('enter_city')"
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.citytextErrors
                : []
            "
            outlined
            required
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <label
            >{{ $t("postalCode") }}<span style="color: #f00">*</span></label
          >
          <v-autocomplete
            v-model="businessAddress.zip_code"
            :items="postalCodeslist"
            :rules="
              !addProfilePayload.is_mailing_address_same_as_business_address
                ? EntityRules.postalCodeErrors
                : []
            "
            :placeholder="$t('postal_code_placeholder')"
            outlined
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            v-if="is_update"
            color="primary"
            class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="updateEntityinfo"
            >{{ $t("Update") }}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="onClickNext"
            >{{ $t("Save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <loading
      :active="loader"
      :is-full-page="true"
      :opacity="0.9"
      color="#ff6b00"
    />
  </v-container>
</template>

<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Loading from "vue-loading-overlay";
import { entityTypes } from "@/utils/BusDocuments";
import commonService from "@/services/CommonService/commonService.js";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
import { i18n as $ } from "@/locale/index";
export default {
  mixins: [alerts],
  data: () => ({
    isValidNumber: false,
    valid: true,
    is_update: false,
    loader: false,
    entityType_options: [],
    entityTypes: entityTypes(),
    source_options: [],
    doistate: false,
    source_of_funds: "",
    addProfilePayload: {
      entity_type: "",
      business_name: "",
      registration_number: "",
      nature_of_business: "",
      website: "",
      business_email: "",
      street_number: "",
      mailing_address: "",
      mailing_country: "",
      mailing_state: "",
      mailing_city: "",
      mailing_postal_code: "",
      is_mailing_address_same_as_business_address: false,
      dob: null,
      source_of_fund_code: "",
      phone_number: "",
      salary_range: "",
      address: "",
      country_code: "",
      state_code: "",
      city_code: "",
      zip_code: "",
    },
    country_options: [],
    state_options: [],
    city_options: [],
    maling_city_options: [],
    isSubmitted: false,
    addressInfo: {
      mailing_address: "",
      mailing_country: "",
      mailing_state: "",
      mailing_city: "",
      mailing_postal_code: "",
    },
    businessAddress: {
      street_number: "",
      address: "",
      country_code: {},
      state_code: "",
      city_code: "",
      zip_code: "",
    },
    EntityRules: {
      entity_typeRules: [(v) => !!v || $.t("entity_typeRules")],
      CompanyNameRules: [(v) => !!v || $.t("CompanyNameRules")],
      RegistrationNoRules: [(v) => !!v || $.t("RegistrationNoRules")],
      DoiRules: [(v) => !!v || $.t("DoiRules")],
      SOFrules: [(v) => !!v || $.t("SOFrules")],
      natureOfBusinessErrors: [(v) => !!v || $.t("natureOfBusinessErrors")],
      contactNoErrors: [(v) => !!v || $.t("contactNoErrors")],
      emailValidations: [
        (v) => !!v || $.t("email_errors"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          $.t("invalid_email"),
      ],
      turnoverErrors: [(v) => !!v || $.t("turnoverErrors")],
      corporateAddErrors: [
        (v) => !!v || $.t("address_req"),
        (v) => v.length < 98 || $.t("address_minlength"),
      ],
      countryErrors: [(v) => !!v || $.t("country_field_required")],
      mailingStateErrors: [(v) => !!v || $.t("state_field_is_required")],
      mailingCityErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      stateErrors: [(v) => !!v || $.t("state_field_is_required")],
      cityErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      citytextErrors: [(v) => !!v || $.t("city_placeholder_beneficary")],
      postalCodeErrors: [
        (v) => !!v || $.t("postalcode_placeholder_beneficary"),
      ],
    },
    haveCities: true,
    haveBusCities: true,
    postalCodeslist: [],
    natureofbusList: [],
  }),
  name: "BasicDetails",

  components: {
    VuePhoneNumberInput,
    Loading,
  },

  watch: {
    "addProfilePayload.entity_type"(val) {
      let entity_type = this.entityTypes.entityTypes.find(
        (type) => type.value_code === val
      );
      let entity_name = entity_type.value;
      if (entity_name) {
        this.$emit("selctedEntitytype", entity_name);
      }
    },
    "addProfilePayload.dob"(val) {
      const incorpDate = "2017-01-31";
      console.log(incorpDate);
      console.log(
        "addProfilePayload.entity_type",
        this.addProfilePayload.entity_type
      );
      console.log("time", val);
      if (this.addProfilePayload.entity_type === "1" && val > incorpDate) {
        this.$emit("isHideform", "form_9");
      } else if (
        this.addProfilePayload.entity_type === "1" &&
        val < incorpDate
      ) {
        this.$emit("isHideform", "form_51");
      }
    },
  },
  created() {
    if (this.$route.query.customer_id) {
      this.getentitydetails();
    }
    this.getEntityType();
    this.addProfilePayload.entity_type = "1";
    this.getCountryList();
    this.getPostalCodes();
    this.addressInfo.mailing_country = "MYS";
    this.businessAddress.country_code = "MYS";
    this.getSourceFunds();
    this.getnatureOfBusiness();
    this.onChangeCounty("MYS");
  },
  methods: {
    ValidateDateofIncop(value) {
      console.log("value", value);
      let presentDay = new Date().toJSON().slice(0, 10);
      console.log("presentDay", presentDay);
      if (value > presentDay) {
        this.doistate = true;
        this.EntityRules.DoiRules.push($.t("invalid_doi"));
      } else {
        this.doistate = false;
        this.EntityRules.DoiRules = [
          (v) => !!v || $.t("postalcode_placeholder_beneficary"),
        ];
      }
    },
    onChangeNumber(e) {
      this.isValidNumber = e.isValid;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },

    async getentitydetails() {
      this.loader = true;
      try {
        const response = await businessService.getEntityinformation({
          customer_id: this.$route.query.customer_id,
        });
        if (response.data.status_code == 200) {
          this.is_update = true;
          this.combinedData = response.data.data[0];
          this.addProfilePayload = {
            entity_type: response.data.data[0].entity_type
              ? response.data.data[0].entity_type.value_code
              : "",
            business_name: response.data.data[0].business_name,
            registration_number: response.data.data[0].registration_number,
            business_email: response.data.data[0].business_email,
            nature_of_business: response.data.data[0].nature_of_business
              ? response.data.data[0].nature_of_business.value_code
              : null,
            is_mailing_address_same_as_business_address:
              response.data.data[0].is_mailing_address_same_as_business_address,
            website: response.data.data[0].website,
            dob: response.data.data[0].dob,
            source_of_fund_code: response.data.data[0].source_of_fund_code
              ? response.data.data[0].source_of_fund_code.value_code
              : null,
            salary_range: response.data.data[0].salary_range,
            phone_number: response.data.data[0].phone_number,
          };

          console.log("uu", this.addProfilePayload);
          (this.addressInfo = {
            mailing_address: response.data.data[0].mailing_address,
            mailing_country: response.data.data[0].mailing_country
              ? response.data.data[0].mailing_country.iso_alpha3
              : null,
            mailing_state:
              response.data.data[0] && response.data.data[0].mailing_state
                ? response.data.data[0].mailing_state.state_code
                : null,
            mailing_city: response.data.data[0].mailing_city
              ? response.data.data[0].mailing_city.id
              : null,
            mailing_postal_code: response.data.data[0].mailing_postal_code,
          }),
            console.log("add", this.addressInfo);
          (this.businessAddress = {
            street_number: response.data.data[0].street_number
              ? response.data.data[0].street_number
              : null,
            address: response.data.data[0].address
              ? response.data.data[0].address
              : null,
            country_code: response.data.data[0].country_code
              ? response.data.data[0].country_code.iso_alpha3
              : null,
            state_code: response.data.data[0].state_code
              ? response.data.data[0].state_code.state_code
              : null,
            city_code: response.data.data[0].city_code
              ? response.data.data[0].city_code.id
              : null,
            zip_code: response.data.data[0].zip_code
              ? response.data.data[0].zip_code
              : null,
          }),
            (this.loader = false);
          console.log("buu", this.businessAddress);
          console.log("response", response);
        } else {
          this.loader = false;
          this.is_update = false;
          // this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async onClickNext() {
      if (this.$refs.busEntity.validate()) {
        const combinedData = {
          ...this.addProfilePayload,
          ...this.addressInfo,
          ...this.businessAddress,
        };
        console.log("combinedData", combinedData);
        this.loader = true;
        try {
          const responseData = await businessService.addEntityinformation(
            combinedData,
            {
              partner_id: sessionStorage.getItem("partner_id"),
            }
          );
          if (responseData && responseData.data.status_code == 200) {
            this.loader = false;
            this.$router.replace(
              `/addBusCustomer?customer_id=${responseData.data.data[0].master_customer_id}`
            );
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.loader = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          console.error(error);
          this.loader = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async updateEntityinfo() {
      if (this.$refs.busEntity.validate()) {
        const combinedData = {
          ...this.addProfilePayload,
          ...this.addressInfo,
          ...this.businessAddress,
        };
        this.loader = true;
        try {
          const responseData = await businessService.updateEntityinformation(
            combinedData,
            {
              customer_id: this.$route.query.customer_id,
            }
          );
          if (responseData && responseData.data.status_code == 200) {
            this.loader = false;
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.loader = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          console.error(error);
          this.loader = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async getSourceFunds() {
      try {
        const responseData = await commonService.getparameterdropdowns("SOF");
        if (responseData.data.status_code === 200) {
          this.source_options = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
          if (
            this.is_update &&
            this.combinedData?.source_of_fund_code &&
            this.combinedData?.source_of_fund_code.value_code
          ) {
            this.addProfilePayload.source_of_fund_code = this.combinedData
              .source_of_fund_code
              ? this.combinedData.source_of_fund_code.value_code
              : null;
          }
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getnatureOfBusiness() {
      try {
        const responseData = await commonService.getparameterdropdowns("NOB");
        if (responseData.data.status_code === 200) {
          this.natureofbusList = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
          if (
            this.is_update &&
            this.combinedData?.nature_of_business &&
            this.combinedData?.nature_of_business.value_code
          ) {
            this.addProfilePayload.nature_of_business = this.combinedData
              .nature_of_business
              ? this.combinedData.nature_of_business.value_code
              : null;
          }
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getPostalCodes() {
      try {
        const responseData = await commonService.getZipCodes();
        if (responseData.data.status_code === 200) {
          this.postalCodeslist = [...responseData.data.data];
        }
        console.log("postalCodes", responseData);
      } catch (err) {
        console.log(err);
      }
    },

    async getCountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return { name: i.country_name, id: i.iso_alpha3 };
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },

    async onChangeCounty(iso3) {
      try {
        const responseData = await commonService.getStatesList(iso3);
        if (responseData.data.status_code === 200) {
          this.state_options = responseData.data.data.map((i) => {
            return {
              name: i.name,
              id: i.state_code,
            };
          });
          if (this.is_update && this.combinedData.mailing_state) {
            this.onChangeState(this.combinedData.mailing_state.state_code);
          }
          if (this.is_update && this.combinedData.state_code) {
            this.onChangemailingState(this.combinedData.state_code.state_code);
          }
        }

        console.log("States", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async onChangemailingState(state, resetSelection = false) {
      if (resetSelection) this.businessAddress.city_code = "";
      this.haveBusCities = true;
      this.maling_city_options = [];
      try {
        const responseData = await commonService.getCitiesList(
          this.businessAddress.country_code,
          state
        );
        if (responseData.data.status_code === 200) {
          this.maling_city_options = responseData.data.data.map((i) => {
            return {
              val: i.id,
              txt: i.name,
            };
          });
          if (this.is_update && this.combinedData?.city_code?.id && !resetSelection) {
            this.businessAddress.city_code = parseInt(
              this.combinedData.city_code.id
            );
          }
          if (this.maling_city_options.length === 0) {
            this.haveBusCities = false;
            if (!resetSelection && this.combinedData?.city_code?.name) {
              this.businessAddress.city_code = this.combinedData.city_code.name;
            }
          } else {
            this.haveBusCities = true;
            console.log("have list");
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async onChangeState(state, resetSelection = false) {
      if (resetSelection) this.addressInfo.mailing_city = "";
      this.haveCities = true;
      this.city_options = [];
      try {
        const responseData = await commonService.getCitiesList(
          this.addressInfo.mailing_country,
          state
        );
        if (responseData.data.status_code === 200) {
          this.city_options = responseData.data.data.map((i) => {
            return {
              val: i.id,
              txt: i.name,
            };
          });
          if (this.is_update && this.combinedData?.mailing_city?.id && !resetSelection) {
            console.log("city", this.city_options);
            this.addressInfo.mailing_city = parseInt(
              this.combinedData.mailing_city.id
            );
          }
          if (this.city_options.length === 0) {
            this.haveCities = false;
            if (!resetSelection && this.combinedData?.mailing_city?.name) {
              this.addressInfo.mailing_city = this.combinedData.mailing_city.name;
            }
          } else {
            this.haveCities = true;
            console.log("have list");
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    async getEntityType() {
      try {
        const responseData = await commonService.getparameterdropdowns("ETD");
        if (responseData.data.status_code === 200) {
          this.entityType_options = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
